// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"824":"d5735946","3356":"b157363f","3968":"d00051f5","4776":"656fcfed","4823":"65861db3","4936":"656fcfed","7519":"656fcfed","7912":"656fcfed","9028":"656fcfed","9888":"d00051f5"}[chunkId] + ".chunk.css";
};